import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    loading: 0,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.INCREMENT_LOADING_ONLINE_TESTS:
            return { ...state, loading: state.loading + 1 };
        case actions.DECREMENT_LOADING_ONLINE_TESTS:
            return { ...state, loading: state.loading - 1 };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/online-tests/online-tests.reducer.js